import React, { Fragment } from "react";
import type { NavigationItem } from "../../../constants/navigationConstants";
import type { PageInfo } from "../../../constants/pages";
import {
  DropdownGrid,
  DropdownItem,
  FooterNavContainer,
  NavColumn,
  NavLink,
} from "./FooterNav.styled";

interface FooterNavProps {
  links: NavigationItem[];
}

const FooterNav: React.FC<FooterNavProps> = ({ links }) => {
  const dropdowns = links.filter((x) => x.dropdown);
  return (
    <FooterNavContainer>
      <NavColumn>
        {links.map((link, index) => (
          <Fragment key={index}>
            {link.route && !link.dropdown && (
              <NavLink to={link.route}>{link.title}</NavLink>
            )}
          </Fragment>
        ))}
      </NavColumn>
      {dropdowns.map((dropdown, index) => (
        <NavColumn key={index}>
          <NavLink to={dropdown.route ?? dropdown.dropdown?.[0].route ?? ""}>
            {dropdown.title}
          </NavLink>
          <DropdownGrid>
            {dropdown.dropdown &&
              dropdown.dropdown.map((item: PageInfo | undefined, itemIndex) => (
                <Fragment key={itemIndex}>
                  {item?.route && (
                    <DropdownItem to={item.route}>{item.title}</DropdownItem>
                  )}
                </Fragment>
              ))}
          </DropdownGrid>
        </NavColumn>
      ))}
    </FooterNavContainer>
  );
};

export default FooterNav;
